import AudioCubeApiCallerInstance from "../utils/AudioCubeApiCallerInstance";
import { SOUNDBOX_API_ENDPOINTS } from "../URLConstants";

export const GetAllDevices = async(pageNo,limit,organizationId,name,merchantDeviceId,phone)=>{
   
        const response = await AudioCubeApiCallerInstance.get(`${SOUNDBOX_API_ENDPOINTS.DEVICE_LIST}?page=${pageNo}&limit=${limit}&organizationId=${organizationId}&name=${name}&merchantDeviceId=${merchantDeviceId}&phone=${phone}`)
        return response;
   
}

export const GetAllDevicesWithTrans = async(pageNo,limit,organizationId,location,language,serachBy)=>{
   
        const response = await AudioCubeApiCallerInstance.post(`${SOUNDBOX_API_ENDPOINTS.DEVICE_LIST_WITH_TRANS}?page=${pageNo}&limit=${limit}`,{
                "organizationId": organizationId,
                "location"     : location,
                "language"     : language,
                "search_by"     : serachBy
        })
        return response;
   
}

export const GetDeviceTransactions= async(organizationId,deviceId,fileterType,serachBy,pageNo,limit)=>{
        
        const response = await AudioCubeApiCallerInstance.post(`${SOUNDBOX_API_ENDPOINTS.GET_DEVICE_TRANSACTION}?page=${pageNo}&limit=${limit}`,{
                "organizationId": organizationId,
                "device_id"     : deviceId,
                "filter_type"     : fileterType,
                "search_by"     : serachBy
        })
        return response;
}


export const GetDeviceById = async(organizationId,deviceId)=>{

        const response = await AudioCubeApiCallerInstance.post(`${SOUNDBOX_API_ENDPOINTS.GET_DEVICE_BY_ID}`,{
                "organizationId":organizationId,
                "device_id"     : deviceId,
                "language"     : "",
                "search_by"     : ""
        })
        return response;
   
}

export const DeviceEventRequestByServer=async(organizationId,merchantSeverId,merchantDeviceId,eventType,timeStamp,opts)=>{

        const response = await AudioCubeApiCallerInstance.post(`${SOUNDBOX_API_ENDPOINTS.DEVICE_REBOOT_REQUEST}`,{
                "merchant_id"    : merchantSeverId,// use merchant auto id
                "organizationId" : organizationId,
                "merchant_device_id": merchantDeviceId,
                "event_type"       : eventType,
                "timestamp"        :  timeStamp,
                "opts"            : opts
        })
        return response;
}

export const GetDeviceDeatilsById=async(deviceId)=>{
        
        const response = await AudioCubeApiCallerInstance.get(`${SOUNDBOX_API_ENDPOINTS.GET_MERCHANT_HEARTBEAT_BY_SHADOW}${deviceId}`)
        return response;
}

export const GetDevicePaymentStats=async(startDate,endDate,where)=>{

        const response = await AudioCubeApiCallerInstance.get(`${SOUNDBOX_API_ENDPOINTS.GET_DEVICE_PAYMENT_STATS}`,{
                params:{
                "startDate":startDate,
                "endDate":endDate,
                 "where":JSON.stringify(where)
                }
             })
        return response;
}
